import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { buildQueryString, exportFile } from "../../../utils/utilities";
import { useFormik } from "formik";
import { cloneDeep, get, toLower } from "lodash";
import { useTranslation } from "react-i18next";
import { langDate, langMonth } from "../../../utils/properties";
import { Col, Row, Select, DatePicker } from "antd";
import { DownloadOutlined, ClearOutlined } from "@ant-design/icons";
import Button from "../../../components/functional_components/Button/PFButton";
import ExportProjectTask from "../../../services/api/ExportProjectTask";
import { setLoading } from "../../../redux/ducks/Loading";
import dayjs from "dayjs";
const { Option } = Select;

const ExportSap = () => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const currentLanguage = useSelector((state) => get(state.languageDuck, "currentLanguage", "GB"));
  const dateFormat = langMonth[toLower(currentLanguage)];
  const [state, setState] = useState({
    suppliersOptionsList: [],
    filterLoading: false,
  });
  const formikFilter = useFormik({
    initialValues: {
      month: "",
      suppliersId: [],
    },
    validate: (values) => {
      let errors = {};
      if (!values.month) {
        errors.month = "Required!";
      }
      return errors;
    },
    enableReinitialize: true,
    onSubmit: async (values) => {
      dispatch(setLoading(true));
      const filterSubmit = cloneDeep(values);
      filterSubmit.month = dayjs(values.month, "YYYYMM").format("YYYYMM");
      const queryString = buildQueryString({}, filterSubmit);
      const exportResponse = await ExportProjectTask.exportSap(queryString.string);
      if (exportResponse) {
        const blob = new Blob([exportResponse]);
        exportFile(blob, "project-task.csv");
      }
      dispatch(setLoading(false));
    },
  });

  const changeSupplierFilter = (value) => {
    formikFilter.setFieldValue("suppliersId", value);
    if (value === undefined) {
      setState((prevState) => ({ ...prevState, suppliersOptionsList: [] }));
    }
  };

  const changeDatePicker = async (date) => {
    formikFilter.setFieldValue("month", date);
    const formattedDate = dayjs(date, "YYYYMM").format("YYYYMM");
    let dataopt = [];
    setState((prevState) => ({ ...prevState, filterLoading: true }));
    const suppliers = await ExportProjectTask.getSuppliersExportSap(`month=${formattedDate}`);
    if (suppliers && suppliers.data) {
      suppliers.data.forEach((c) => {
        dataopt.push({ value: c.id, label: c.name });
      });
      setState((prevState) => ({
        ...prevState,
        suppliersOptionsList: dataopt,
      }));
    }
    setState((prevState) => ({ ...prevState, filterLoading: false }));
  };

  return (
    <div className="filter-container">
      <Row gutter={[48, 32]} align="bottom">
        <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">{t("exportSap.month")}*</label>
          </Row>
          <Row>
            <DatePicker
              picker="month"
              id="month"
              name="month"
              format={dateFormat}
              locale={langDate[`locale_${toLower(currentLanguage)}`]}
              value={formikFilter.values.month}
              onChange={(date) => changeDatePicker(date)}
            />
          </Row>
        </Col>
        <Col span={8}>
          <Row>
            <label className="fw-bold mt-10">{t("exportSap.suppliers")}</label>
          </Row>
          <Row>
            <Select
              mode="multiple"
              allowClear
              className="w-100"
              id="suppliersId"
              name="suppliersId"
              showSearch
              placeholder={t("exportSap.suppliersPlaceholder")}
              onChange={changeSupplierFilter}
              onBlur={formikFilter.handleBlur}
              filterOption={(input, option) => option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}
              value={formikFilter.values.suppliersId}
            >
              {state.suppliersOptionsList.length > 0 &&
                state.suppliersOptionsList.map((data) => {
                  return (
                    <Option key={data.label} value={data.value} name={data.label}>
                      {data.label}
                    </Option>
                  );
                })}
            </Select>
          </Row>
        </Col>
        <Col span={8}>
          <Row justify="end">
            <Col>
              <Button
                isDisabled={!(formikFilter.dirty && formikFilter.isValid)}
                type="secondary"
                currentSize="large"
                clickCallback={formikFilter.resetForm}
                currentIcon={<ClearOutlined className="icon-large" />}
              />
            </Col>
            <Col className="left-margin">
              <Button
                isDisabled={!(formikFilter.dirty && formikFilter.isValid)}
                currentSize="large"
                isLoading={state.filterLoading}
                clickCallback={formikFilter.submitForm}
                currentIcon={<DownloadOutlined className="icon-large" />}
              />
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};

export default ExportSap;
